div
<template>
  <div class="app-container">
    <div class="card">
      <el-form
        ref="form"
        :model="queryParams"
        :inline="true"
        @keyup.enter.native="handleQuery"
      >
        <el-form-item label="企业名称：">
          <el-input
            v-model="queryParams.unitName"
            placeholder="请输入企业名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">
            搜 索
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="mainContainer">
      <!-- tab切换：待匹配 / 待更新 / 已更新 -->
      <div class="toponsd">
        <el-tabs v-model="queryParams.activeName" @tab-click="handleClick">
          <el-tab-pane label="待匹配" name="three" />
          <el-tab-pane label="待更新" name="one" />
          <el-tab-pane label="已更新" name="two" />
        </el-tabs>
      </div>

      <!-- 表格容器，包含表格和分页 -->
      <div class="table-container">
        <el-table v-loading="loading" :data="tableData" border height="100%">
          <el-table-column prop="unitName" label="企业名称" align="center" />
          <el-table-column
            prop="certificateType"
            label="证件类型"
            align="center"
          >
            <template slot-scope="{ row }">
              {{ getCertificateTypeLabel(row.certificateType) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="certificateNumber"
            label="证件编号"
            align="center"
          />
          <el-table-column
            prop="exchangeReviewTime"
            label="首营证件更新时间"
            align="center"
          />
          <!-- 待匹配列表不展示上次经营管理更新时间 -->
          <el-table-column
            v-if="queryParams.activeName !== 'three'"
            prop="lastScopeUpdateTime"
            label="上次经营管理更新时间"
            align="center"
          />
          <!-- 待匹配：操作列为「匹配」 -->
          <el-table-column
            v-if="queryParams.activeName === 'three'"
            label="操作"
            width="120"
            align="center"
          >
            <template slot-scope="{ row }">
              <span class="btsed" @click="openMatchDialog(row)">匹配</span>
            </template>
          </el-table-column>
          <!-- 待更新：操作列为「经营管理更新」 -->
          <el-table-column
            v-if="queryParams.activeName === 'one'"
            label="操作"
            width="200"
            align="center"
          >
            <template slot-scope="{ row }">
              <span class="btsed" @click="BusinessManage(row)">
                经营管理更新
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.currPage"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
        />
      </div>
    </div>

    <!-- 手动匹配客户弹窗 -->
    <CustomerMatchDialog
      v-model="matchDialogVisible"
      :customerId="matchCustomerId"
      @success="onMatchSuccess"
    />

    <!-- 经营管理更新弹窗 -->
    <CustInformation
      v-model="dialogVisible"
      :customerId="currentRow.id"
      entryMode="edit"
      :routerType="3"
      @submitted="onSubmitted"
      @closed="dialogVisible = false"
    />

    <ShareReceiveCompanyDialog
      v-model="shareDialogVisible"
      :customerId="shareCustomerId"
      @success="onShareSuccess"
    />
  </div>
</template>

<script>
import { getCustomerScopeList } from "@/api/appApi/appapi.js";
import ShareReceiveCompanyDialog from "@/components/ShareReceiveCompanyDialog/index.vue";
import CustomerMatchDialog from "@/components/CustomerMatchDialog/index.vue";

export default {
  name: "",
  components: { ShareReceiveCompanyDialog, CustomerMatchDialog },
  data() {
    return {
      queryParams: {
        currPage: 1, // 页码
        pageSize: 10, // 每页大小
        unitName: "", // 企业名称
        activeName: "three", // tab状态，默认待匹配
        isMaintainScope: 3, // 1:已更新 2:待更新 3:待匹配
      },

      total: 0,
      loading: false,
      tableData: [], // 列表

      matchDialogVisible: false, // 手动匹配弹窗
      matchCustomerId: "", // 当前待匹配客户ID

      dialogVisible: false, // 经营管理更新弹窗
      currentRow: {}, // 当前操作行

      shareDialogVisible: false,
      shareCustomerId: "",
    };
  },

  created() {
    this.getList();
  },
  methods: {
    // 证件类型文案
    getCertificateTypeLabel(type) {
      const val = String(type ?? "");
      if (val === "1") return "营业执照";
      if (val === "2") return "医疗执业许可证";
      if (val === "3") return "诊所备案凭证";
      return type || "";
    },
    /** 查询列表数据 */
    async getList() {
      this.loading = true;
      let res = await getCustomerScopeList(this.queryParams);
      this.loading = false;
      if (res.code == "000000") {
        this.tableData = res.content.list;
        this.total = res.content.totalRecords;
      }
    },
    // 查询按钮操作
    handleQuery() {
      this.queryParams.currPage = 1;
      this.getList();
    },
    // 重置
    handleReset() {
      Object.assign(this.queryParams, this.$options.data().queryParams);
      this.getList();
    },
    // 切换 tab 状态，映射 isMaintainScope
    async handleClick() {
      this.queryParams.currPage = 1;
      const tabMap = {
        three: 3, // 待匹配
        one: 2, // 待更新
        two: 1, // 已更新
      };
      this.queryParams.isMaintainScope =
        tabMap[this.queryParams.activeName] || 2;
      await this.getList();
    },
    // 打开手动匹配弹窗
    openMatchDialog(row) {
      this.matchCustomerId = row.id;
      this.currentRow = row;
      this.matchDialogVisible = true;
    },
    // 匹配成功后进入经营范围维护
    async onMatchSuccess(customerId) {
      this.queryParams.activeName = "one";
      await this.getList();
      await this.BusinessManage({ id: customerId });
    },
    // 经营管理更新弹窗
    BusinessManage(row) {
      this.currentRow = row;
      this.dialogVisible = true;
    },
    // 数据已更新后弹出共享发送
    onSubmitted() {
      this.getList();
      if (this.queryParams.activeName !== "one") return;
      const id = this.currentRow && this.currentRow.id;
      if (!id) return;
      this.shareCustomerId = id;
      this.$nextTick(() => {
        this.shareDialogVisible = true;
      });
    },
    onShareSuccess() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs__nav-wrap::after {
  background-color: #dfe4ed;
}
.el-form-item {
  margin-bottom: 5px;
}
.toponsd {
  margin-left: 10px;
  position: relative;
  .abobtn {
    position: absolute;
    top: 0px;
    right: 0px;
  }
}
</style>
